<template>
  <section class="border-b border-slate-200 bg-white py-14 md:py-16">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div
        class="overflow-hidden rounded-3xl border border-slate-200 bg-[linear-gradient(120deg,#eff6ff_0%,#ffffff_50%,#fff7ed_100%)] p-7 shadow-sm md:p-10"
      >
        <div class="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
          <div>
            <div
              class="flex items-center gap-1 text-2xl text-amber-400"
              aria-label="Estrelas decorativas"
            >
              <span v-for="star in 5" :key="star">★</span>
            </div>

            <h2 class="mt-3 text-3xl font-black text-[#071a3d]">
              Avaliações da Casa do Software
            </h2>

            <p class="mt-3 max-w-2xl leading-7 text-slate-600">
              Consulte comentários publicados no Google ou compartilhe sua
              experiência de compra e atendimento.
            </p>

            <p class="mt-3 text-xs leading-5 text-slate-500">
              A nota oficial e o conteúdo das avaliações são exibidos
              diretamente pelo Google.
            </p>
          </div>

          <div class="flex flex-col gap-3 sm:flex-row lg:flex-col">
            <a
              :href="googleProfileUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex min-h-12 items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-black text-white transition hover:bg-blue-700"
            >
              Ver avaliações no Google
            </a>

            <a
              :href="googleWriteReviewUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex min-h-12 items-center justify-center rounded-xl border-2 border-blue-600 bg-white px-6 py-3 text-sm font-black text-blue-700 transition hover:bg-blue-50"
            >
              Fazer uma avaliação
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const googleProfileUrl =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("Casa do Software casadosoftware.com.br");

const googleWriteReviewUrl =
  "https://search.google.com/local/writereview?placeid=ChIJv_85JGOL4AgRDOpSmcwViIo";
</script>
